import { reactive } from 'vue'

export default reactive({ task: {}, photo: {}, intervention: {}, product: {}, profile: {},tag: {} })
